export const brand = 'joes';
export const name = 'Joe\'s';
export const braintreeDisplayName = 'Joe\'s';

export const dietLink = 'http://tkmenus.com/jkltakeaway';

export const styleClasses = {
	button: 'btn'
};

export const staticDir = '/static/' + brand;



// WEBPACK FOOTER //
// ./src/brands/joes/settings.js